// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMIcon.tsx — PropelMapper custom icon component.
// Renders an inline, fully recolorable SVG pulled from window.PM_ICONS
// (loaded from assets/icons/icon-data.js). Each icon's colors are exposed as
// CSS variable slots; pass fg/accent/accent2/accent3 (or `color`) to recolor,
// or set --icon-* on any ancestor to tint a whole region.

export function PMIcon({
  name,
  size = 24,
  color,
  fg,
  accent,
  accent2,
  accent3,
  title,
  className = "",
  style = {},
  ...rest
}) {
  const icons = (typeof window !== "undefined" && (window as any).PM_ICONS) || {};
  const svg = icons[name];

  const vars: any = {};
  const front = fg || color;
  if (front) vars["--icon-fg"] = front;
  if (accent) vars["--icon-accent"] = accent;
  if (accent2) vars["--icon-accent-2"] = accent2;
  if (accent3) vars["--icon-accent-3"] = accent3;

  const box = { width: size, height: size, ...vars, ...style };

  if (!svg) {
    return (
      <span
        className={"pm-icon " + className}
        title={"missing icon: " + name}
        style={{ ...box, outline: "1px dashed #C62828", boxSizing: "border-box" }}
        {...rest}
      />
    );
  }

  return (
    <span
      className={"pm-icon " + className}
      role="img"
      aria-label={title || name}
      title={title || name}
      style={box}
      dangerouslySetInnerHTML={{ __html: svg }}
      {...rest}
    />
  );
}
